import { useCallback } from 'react';
import { PolicyTemplate } from '../../../../types/policies';
import { useDelete, UseDeleteParams } from '../../../../api/';
import { TEMPLATES_BASE_URL } from '../consts';

interface DeleteTemplateResponse {
    templateId: PolicyTemplate['id'];
}

interface DeleteTemplateErrorResponse {
    templateId: PolicyTemplate['id'];
    error: string;
}

export type UseDeleteTemplateParams = UseDeleteParams<DeleteTemplateResponse, DeleteTemplateErrorResponse>;

export const useDeletePolicyTemplate = (params: UseDeleteTemplateParams) => {
    const { deleteMethod, loading, error } = useDelete(params);

    const deletePolicyTemplate = useCallback(
        (templateId: PolicyTemplate['id']) => deleteMethod(`${TEMPLATES_BASE_URL}/${templateId}`),
        [deleteMethod]
    );

    return {
        loading,
        error,
        deletePolicyTemplate
    };
};
